// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../../node_modules/postcss-loader/src/index.js!../../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._3fW24Skex{background-color:#F2F2F2;border-radius:4px;margin-bottom:2px}._43InAjPYx{padding-top:16px}._1dDJWxvWx{}._2Lfe2xrEx{width:40px;height:40px;text-align:center}._2Lfe2xrEx>img{max-width:40px;max-height:40px}._4PSNOigNx svg path{fill:var(--secondary-text)}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"inverted-row": "_3fW24Skex",
	"invertedRow": "_3fW24Skex",
	"devices": "_43InAjPYx",
	"register-device": "_1dDJWxvWx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["standalone-anchor"] + "",
	"registerDevice": "_1dDJWxvWx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["standalone-anchor"] + "",
	"device-icon": "_2Lfe2xrEx",
	"deviceIcon": "_2Lfe2xrEx",
	"delete-button": "_4PSNOigNx",
	"deleteButton": "_4PSNOigNx"
};
module.exports = exports;
